import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Victor Herrera',
    title: "Full Stack & Mobile Developer",
    desciption:"Hope is the thing with feathers That perches in the soul, and sings the tune without the words, and never stops at all. ",
    image: 'https://res.cloudinary.com/dzdnfbynr/image/upload/v1674257891/foto_perfil_redes_de_trabajo-removebg-preview_ivj2ia.png',
    resumePdf: resume
}
